import { Box, Button, paletteColors, Stack, Typography } from '@evaneos/b2b-ui';

import { PARTNER_URL } from '../constants/urls';

const HERO_IMAGE =
    'https://static1.evcdn.net/images/reduction/1823890_w-1200_h-675_q-70_m-crop.jpg';

export const TravelSuiteHero = () => (
    <Box
        component="section"
        sx={{
            backgroundColor: paletteColors.neutral[100],
            px: { xs: 2, md: 8 },
            py: { xs: 8, md: 12 },
        }}
    >
        <Box
            sx={{
                maxWidth: '1200px',
                mx: 'auto',
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
                gap: { xs: 6, md: 10 },
                alignItems: 'center',
            }}
        >
            <Stack spacing={4}>
                <Typography
                    variant="titleMoretXL"
                    component="h1"
                    sx={{ color: paletteColors.neutral[900], lineHeight: 1.2 }}
                >
                    The digital toolkit for your travel agency
                </Typography>
                <Typography
                    variant="body1"
                    sx={{ color: paletteColors.neutral[700], fontSize: '1.8rem', lineHeight: 1.7 }}
                >
                    Everything you need to manage your clients, build tailor-made proposals, and
                    grow your agency, in one platform designed for travel experts.
                </Typography>
                <Box>
                    <Button
                        href={PARTNER_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        variant="contained"
                        size="large"
                    >
                        Become a partner
                    </Button>
                </Box>
            </Stack>
            <Box
                sx={{
                    display: { xs: 'none', md: 'block' },
                    height: '420px',
                    borderRadius: 3,
                    overflow: 'hidden',
                }}
            >
                <img
                    src={HERO_IMAGE}
                    alt="Travel agency scenic view"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                />
            </Box>
        </Box>
    </Box>
);
